import { Component, OnInit } from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../../shared/message.service';
import { TopicService } from '../topic.service';

@Component({
  selector: 'app-new-image-compression',
  templateUrl: './new-image-compression.component.html',
  styleUrls: ['./new-image-compression.component.css']
})
export class NewImageCompressionComponent extends GeneralExerciseComponent {

  image: string[][];
  solution: string;
  compressedText: string = "";
  highlight: boolean;

  caretPosition: number;
  position: number[];

  errors: number[][] = [];

  lower: number;
  upper: number;

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService)
  }

  setTypeSpecificsFromConfiguration() {
    this.image = this.configuration.typespecifics.image;
    this.highlight = this.configuration.typespecifics.highlight;
    this.compressedText = "";

    //compute solution
    let imageString = this.image.map(v => v.join("")).join("");
    let lastSign = "";
    let count = 0;

    this.solution = "";
    for (let c of imageString) {
      if (c == lastSign) {
        count++;
      } else {
        if (count > 0) {
          this.solution = this.solution.concat(count.toString(), lastSign);
        }
        lastSign = c;
        count = 1;
      }
    }
    this.solution = this.solution.concat(count.toString(), lastSign);

    this.position = []
    let counts = this.solution.split(/([0-9]+)/);
    console.log(counts);
    let presum = 0;
    for (let i = 0; i < counts.length; i++) {
      if (Number.isNaN(+counts[i])) {
        this.position.push(presum);
      } else {
        presum += +counts[i];
        for (let j = 0; j < counts[i].length; j++) {
          this.position.push(presum);
        }
      }
    }

    this.printable = true;
  }

  setTypeSpecificsFromState() {
    if (this.state.typespecific) {
      if (this.state.typespecific.compressedText) {
        this.compressedText = this.state.typespecific.compressedText;
      }
    }
  }

  computeState() {
    this.state.typespecific.compressedText = this.compressedText;
  }


  /** returns expanded name of abbreviated color */
  color(c: string) {
    switch (c) {
      case "k": return "black";
      case "c": return "cyan";
      case "m": return "magenta";
      case "y": return "yellow";
      case "r": return "red";
      case "g": return "green";
      case "b": return "blue";
      default: return "white";
    }
  }

  checkSolution() {
    let imageString = this.image.map(v => v.join("")).join("");
    let solution = this.solution;
    let counts = this.compressedText.split(/([0-9]+)/);
    let studentImage = "";

    for (let i = 1; i < counts.length; i += 2) {
      studentImage = studentImage.concat(counts[i + 1].repeat(+counts[i]));
    }

    this.errors = [];
    if (imageString != studentImage) {
      this.messageService.addAlertWithTimeout(this.get("wrongImage"), "danger", 10000);
      this.errors = imageString.split("").map((v, i) => [v, i]).filter(v => v[0] != studentImage.charAt(+v[1])).map(v => v[1]).map(v => [Math.floor(+v / 20), +v % 20]);
      return;
    }

    if (this.compressedText != solution) {
      this.messageService.addAlertWithTimeout(this.get("wrongImageCompression"), "danger", 10000);
      return;
    }

    this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
    this.state.solved = true;
    this.solved = true;
    this.saveState();

  }

  evaluate(): number[] {
    let imageString = this.image.map(v => v.join("")).join("");

    let studentImage = "";
    let counts = this.compressedText.split(/([0-9]+)/);

    for (let i = 1; i < counts.length; i += 2) {
      studentImage = studentImage.concat(counts[i + 1].repeat(+counts[i]));
    }
    let errors = imageString.split("").map((v, i) => [v, i]).filter(v => v[0] != studentImage.charAt(+v[1])).map(v => v[1]).map(v => [Math.floor(+v / 20), +v % 20]);
    if (this.compressedText != this.solution) {
      return [(400 - errors.length) / 400 * 3, 5];
    }
    return [(400 - errors.length) / 400 * 5, 5];
  }


  /** is the given pixel currently selected?  */
  inCurrent(i: number, j: number) {
    let pixel = i * 20 + j;
    if (pixel >= this.lower && pixel < this.upper) {
      return true;
    } else {
      return false;
    }
  }

  /** is the given pixel errorneous? */
  inError(i: number, j: number): boolean {

    for (let e of this.errors) {
      if (i == e[0] && j == e[1]) {
        return true;
      }
    }
    return false;
  }


  /** update the pixels to highlight */
  setCaret(oField) {
    if (oField.selectionStart || oField.selectionStart == '0') {
      this.caretPosition = oField.selectionStart;
    }
    let counts = this.compressedText.slice(0, this.caretPosition).split(/([0-9]+)/);
    let index = counts.length;
    this.lower = counts.slice(0, index - 2).filter(v => !Number.isNaN(+v)).reduce((a, b) => (+a + +b), 0);
    this.upper = counts.filter(v => !Number.isNaN(+v)).reduce((a, b) => (+a + +b), 0);
  }




}
